import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@clerk/react";
import { Phone, MessageCircle, Send, HandCoins, Lock, MessageSquare } from "lucide-react";
import { toast } from "sonner";
import { useAuthedApi, errMsg } from "../lib/api";
import LeadDialog from "./LeadDialog";
import OfferDialog from "./OfferDialog";

const waNumber = (p) => { const d = p.replace(/\D/g, ""); return d.length === 10 ? `91${d}` : d; };

export default function ContactActions({ car }) {
  const { isSignedIn } = useAuth();
  const api = useAuthedApi();
  const navigate = useNavigate();
  const [phone, setPhone] = useState(null);
  const [dialog, setDialog] = useState(null);

  const guard = (fn) => () => (isSignedIn ? fn() : navigate(`/sign-in?redirect_url=${encodeURIComponent(window.location.href)}`));
  const reveal = async () => {
    try {
      const c = await api("get", `/listings/${car.id}/contact`);
      setPhone(c.seller_phone);
      return c.seller_phone;
    } catch (e) { toast.error(errMsg(e)); }
  };
  const whatsapp = async () => {
    const p = phone || (await reveal());
    if (!p) return;
    const text = encodeURIComponent(`Hi, I'm interested in your ${car.year} ${car.brand} ${car.model} listed on carsalemarket.com`);
    window.open(`https://wa.me/${waNumber(p)}?text=${text}`, "_blank");
  };
  const chat = async () => {
    try { navigate(`/chat/${(await api("post", "/threads", { listing_id: car.id })).thread_id}`); } catch (e) { toast.error(errMsg(e)); }
  };
  const sold = car.status === "sold";

  return (
    <div className="space-y-3" data-testid="contact-actions">
      {!sold && (
        <button onClick={guard(() => setDialog("offer"))} className="btn-gold w-full !py-3 text-base shadow-[0_8px_30px_rgba(212,175,55,0.35)]" data-testid="car-detail-make-offer-button"><HandCoins className="w-5 h-5" /> Make an Offer</button>
      )}
      {phone ? (
        <a href={`tel:${phone}`} className="w-full flex items-center justify-center gap-2 py-3 rounded-full border border-[#D4AF37]/50 text-[#F5E08F] bg-[#D4AF37]/10 font-semibold" data-testid="seller-phone-link">
          <Phone className="w-4 h-4" /> {phone}
        </a>
      ) : (
        <button onClick={guard(reveal)} className="btn-outline w-full" data-testid="car-detail-call-button">
          {isSignedIn ? <Phone className="w-4 h-4" /> : <Lock className="w-4 h-4" />} {isSignedIn ? "Show Phone Number" : "Sign in to view phone"}
        </button>
      )}
      <button onClick={guard(whatsapp)} className="w-full flex items-center justify-center gap-2 py-3 rounded-full bg-[#25D366] hover:bg-[#1ebe5a] text-black font-semibold transition-colors" data-testid="car-detail-whatsapp-button">
        <MessageCircle className="w-4 h-4" /> Chat on WhatsApp
      </button>
      <div className="grid grid-cols-2 gap-3">
        <button onClick={guard(chat)} disabled={sold} className="btn-outline !px-3 text-sm disabled:opacity-40" data-testid="car-detail-chat-button"><MessageSquare className="w-4 h-4" /> Chat with seller</button>
        <button onClick={guard(() => setDialog("enquiry"))} className="btn-outline !px-3 text-sm" data-testid="car-detail-enquiry-button"><Send className="w-4 h-4" /> Enquire</button>
      </div>
      {dialog === "enquiry" && <LeadDialog open onOpenChange={(o) => !o && setDialog(null)} type="enquiry" car={car} />}
      {dialog === "offer" && <OfferDialog open onOpenChange={(o) => !o && setDialog(null)} car={car} />}
    </div>
  );
}
